import { Observable, of } from 'rxjs'

import { Record, RecordFeatured } from '@skinsoft/types'
import { recordSelectors } from '@skinsoft/selectors'

export function toRecordFeatured$(record: Record, locale: string): Observable<RecordFeatured> {
    const featuredrecord: RecordFeatured = {
        currentState: recordSelectors.currentState(record, locale),
        fromUpdateCache: !!record.fromUpdateCache,
        id: recordSelectors.id(record),
        linkedItemId: recordSelectors.linkedItemId(record),
        recordIdentifier: recordSelectors.recordIdentifier(record),
        linkedItemIdentifier: recordSelectors._linkedItemInventoryNumber(record),
        currentLocationId: recordSelectors.currentLocationId(record)
    }

    return of(featuredrecord)
}